<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" class="pa-2">
        <template v-if="all_runners.length > 0">
          <v-text-field v-model="search_query" label="Rechercher un participant par nom ou dossard"
            prepend-inner-icon="mdi-magnify" clearable hide-details density="comfortable" variant="filled"
            class="mb-3" />

          <v-tabs v-model="results_view_tab" density="compact" color="darkblue" class="mb-2">
            <v-tab value="compact">Vue compacte</v-tab>
            <v-tab value="list">Vue liste</v-tab>
          </v-tabs>

          <v-window v-model="results_view_tab" class="mb-3">
            <v-window-item value="compact">
              <div class="pa-1 bordered rounded bg-grey_3" v-if="courses_list.length > 0">
                <v-sheet color="darkblue text-h6 pa-2">Total: {{ total_pointes }}/{{ total_valides }} inscrits
                  pointés</v-sheet>

                <div class="pa-1 my-2 bg-white bordered rounded" v-for="course in courses_list" :key="course.id_course">
                  <div class="text-body-1 font-weight-bold">
                    <span v-if="course.course_nom">{{ course.course_nom }}</span><span v-else>Inscription non
                      sportive</span>
                  </div>
                  <div class="text-body-2">
                    <div class="d-flex sm-gap mb-2">
                      <v-chip color="darkblue" size="large" density="compact" variant="elevated" elevation="0">{{
                        course.pointe }}/{{ course.total }} pointés</v-chip>
                    </div>
                    <v-progress-linear rounded :model-value="get_progress(course.pointe, course.total)" color="darkblue"
                      height="6"></v-progress-linear>
                  </div>
                </div>
              </div>
            </v-window-item>

            <v-window-item value="list">
              <div class="d-flex flex-wrap align-center ga-2 mb-3">
                <span class="text-body-2 font-weight-medium">Statut :</span>
                <v-btn-toggle v-model="list_pointe_filter" color="darkblue" density="compact" variant="outlined"
                  mandatory divided>
                  <v-btn value="all">Tous</v-btn>
                  <v-btn value="pointe">Pointés</v-btn>
                  <v-btn value="non_pointe">Non pointés</v-btn>
                </v-btn-toggle>
              </div>

              <p v-if="list_filtered_runners.length === 0" class="text-body-2 text-medium-emphasis mb-2">
                <template v-if="debounced_search_query.trim()">Aucun coureur trouvé pour « {{ debounced_search_query
                }} »</template>
                <template v-else-if="list_pointe_filter === 'pointe'">Aucun participant pointé</template>
                <template v-else-if="list_pointe_filter === 'non_pointe'">Aucun participant non pointé</template>
                <template v-else>Aucun participant</template>
              </p>
              <template v-else>
                <v-table density="compact" class="bg-white bordered rounded">
                  <thead>
                    <tr>
                      <th>Dossard</th>
                      <th>Nom</th>
                      <th>Prénom</th>
                      <th>Course</th>
                      <th>Statut</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(runner, index) in paginated_list_runners" :key="runner_search_key(runner, index)">
                      <td>{{ runner.dossard || "—" }}</td>
                      <td>{{ runner.nom }}</td>
                      <td>{{ runner.prenom }}</td>
                      <td>{{ runner.course_nom || "—" }}</td>
                      <td>
                        <v-chip :color="is_pointe(runner.pointe) ? 'green-darken-4' : 'red-darken-4'" variant="elevated"
                          elevation="0" size="small">
                          {{ is_pointe(runner.pointe) ? "Pointé" : "Non pointé" }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                <div class="d-flex justify-space-between align-center flex-wrap ga-2 mt-3">
                  <span class="text-body-2 text-medium-emphasis">{{ list_results_label }}</span>
                  <v-pagination v-if="list_page_count > 1" v-model="list_page" :length="list_page_count"
                    density="compact" :total-visible="7" />
                </div>
              </template>
            </v-window-item>
          </v-window>
        </template>


      </v-col>
      <!-- <v-col cols="12" md="6" class="pa-2">
        <div class="pa-1 bordered rounded bg-grey_3" v-if="courses_list.length > 0">
          <v-sheet color="darkblue text-h6 pa-2">Les participants en attente</v-sheet>
          <div class="pa-1 my-2 bg-white bordered rounded" v-for="course in inscriptions_by_races_pendings" :key="course.id_course">
            <div class="text-body-1 font-weight-bold">
              <span v-if="course.course_nom">{{ course.course_nom }}</span
              ><span v-else>Inscription non sportive</span>
            </div>
            <div class="d-flex sm-gap mb-2 flex-wrap" v-if="course.runners.length > 0">
              <v-chip v-for="(runner, index) in course.runners" :key="runner.dossard ? runner.dossard : index">{{ runner.nom }} {{ runner.prenom }}</v-chip>
            </div>
            <p v-else>Tous les participants ont été accueillis</p>
          </div>
        </div>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service.js";
export default {
  data() {
    return {
      inscriptions_by_course: {},
      search_query: "",
      debounced_search_query: "",
      searchDebounceTimer: null,
      results_view_tab: "compact",
      list_page: 1,
      list_per_page: 30,
      list_pointe_filter: "all",
    };
  },
  watch: {
    list_pointe_filter() {
      this.list_page = 1;
    },
    debounced_search_query(value) {
      this.list_page = 1;
      if (value && value.trim()) {
        this.results_view_tab = "list";
      }
    },
    list_page_count(count) {
      if (this.list_page > count) {
        this.list_page = count;
      }
    },
    search_query(value) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      if (!value || !value.trim()) {
        this.debounced_search_query = value;
        return;
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.debounced_search_query = value;
      }, 500);
    },
  },
  methods: {
    async fetch() {
      let res = await AdminService.getPointageAccueil(this.mainStore.module.id);
      if (res && typeof res === "object") {
        this.inscriptions_by_course = res;
      }
    },
    get_progress(nb, max_inscrits, replace_max = null) {
      if (nb == 0) return 0;
      if (max_inscrits == 0) {
        if (replace_max) return (nb * 100) / replace_max;
        return 100;
      }
      return (nb / max_inscrits) * 100;
    },
    is_pointe(pointe) {
      return pointe == "1" || pointe == 1;
    },
    normalize_search(value) {
      return (value ?? "")
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    runner_search_key(runner, index) {
      return [runner.id_course, runner.dossard, runner.nom, runner.prenom, index].join("-");
    },
    runner_matches_query(runner, query) {
      const dossard = this.normalize_search(runner.dossard);
      const nom = this.normalize_search(runner.nom);
      const prenom = this.normalize_search(runner.prenom);
      const fullName = `${nom} ${prenom}`;
      return (
        dossard.includes(query) ||
        nom.includes(query) ||
        prenom.includes(query) ||
        fullName.includes(query) ||
        `${prenom} ${nom}`.includes(query)
      );
    },
  },
  computed: {
    ...mapStores(useMainStore),
    courses_list() {
      return Object.entries(this.inscriptions_by_course).map(([id_course, course]) => ({
        id_course,
        course_nom: course.course_nom,
        inscriptions: course.inscriptions || [],
        pointe: Number(course.pointe || 0),
        not_pointe: Number(course.not_pointe || 0),
        total: Number(course.total || 0),
      }));
    },
    total_pointes() {
      return this.courses_list.reduce((total, course) => total + course.pointe, 0);
    },
    total_valides() {
      return this.courses_list.reduce((total, course) => total + course.total, 0);
    },
    all_runners() {
      return this.courses_list.flatMap((course) =>
        (course.inscriptions || []).map((runner) => ({
          ...runner,
          course_nom: runner.course_nom || course.course_nom,
          id_course: runner.id_course || course.id_course,
        })),
      );
    },
    displayed_runners() {
      const query = this.normalize_search(this.debounced_search_query.trim());
      if (!query) {
        return this.all_runners;
      }
      return this.all_runners.filter((runner) => this.runner_matches_query(runner, query));
    },
    list_filtered_runners() {
      if (this.list_pointe_filter === "all") {
        return this.displayed_runners;
      }
      if (this.list_pointe_filter === "pointe") {
        return this.displayed_runners.filter((runner) => this.is_pointe(runner.pointe));
      }
      return this.displayed_runners.filter((runner) => !this.is_pointe(runner.pointe));
    },
    list_page_count() {
      if (this.list_filtered_runners.length === 0) {
        return 1;
      }
      return Math.ceil(this.list_filtered_runners.length / this.list_per_page);
    },
    paginated_list_runners() {
      const start = (this.list_page - 1) * this.list_per_page;
      return this.list_filtered_runners.slice(start, start + this.list_per_page);
    },
    list_results_label() {
      const total = this.list_filtered_runners.length;
      if (total === 0) {
        return "";
      }
      const start = (this.list_page - 1) * this.list_per_page + 1;
      const end = Math.min(this.list_page * this.list_per_page, total);
      return `${start}-${end} sur ${total} participant${total > 1 ? "s" : ""}`;
    },
    inscriptions_by_races_pendings() {
      return this.courses_list
        .map((course) => {
          const pending = (course.inscriptions || []).filter((runner) => !this.is_pointe(runner.pointe));
          let runners = pending;
          if (pending.length > 6) {
            runners = [...pending.slice(0, 6), { nom: "", prenom: "..." }];
          }
          return {
            id_course: course.id_course,
            course_nom: course.course_nom,
            runners,
          };
        })
        .filter((course) => course.runners.length > 0);
    },
  },
  async mounted() {
    await this.fetch();
  },
  beforeUnmount() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  },
};
</script>

<style lang="scss" scoped></style>
